<div class="td-wb-call-out__media">
  <ng-content select="[tdWbCallOutMedia]" />
</div>
<div class="td-wb-call-out__icon">
  <ng-content select="[tdWbCallOutIcon]" />
</div>
<div class="td-wb-call-out__content">
  <div class="td-wb-call-out__content-inner">
    <ng-content select="td-wb-call-out-header" />
    <div class="td-wb-call-out__content-data">
      <ng-content />
    </div>
  </div>
  <ng-content select="[tdWbCallOutButton]" />
</div>
@if (dismissible()) {
  <button class="td-wb-call-out__close-button"
          tdWbIconButton
          tdWbIconButtonBackground="clear-grey"
          tdWbIconButtonSize="extra-small"
          [attr.aria-label]="'tdWb.callOut.CLOSE_ARIA' | tdWbTranslate"
          (click)="onClose()">
    <td-wb-icon size="16"
                iconId="close--small" />
  </button>
}
